<script>
	import Carousel from './OVERRIDE_Carousel.svelte';
	import {onDestroy, onMount} from "svelte";
	import {getPagesFixedRandomContent, setPagesFixedRandomContent} from "../../share/utils";

	export let html;
	export let isRightSide;
	export let pageContentIndex;
	
	let slider;

	let getNewSentence = () => {};
	
	function initialCarouselSetup() {
		// Select the node that will be observed for mutations
		const visibleImage = slider?.querySelector(`img:last-of-type`) || false;
		if (!slider || !visibleImage) {
			requestAnimationFrame(initialCarouselSetup);
			return;
		}
		const pixelWalls = slider?.querySelectorAll(`img.be_live_background`) || false;
		if (!pixelWalls) {
			return;
		}
		
		pixelWalls.forEach(oldPixelWallDiv => {
			
			const beOriginDOM = `
			 <div class="pixels">
				<canvas width="1183" height="946"></canvas>
				<div class="pixels-message fixed" onClick="BEW.scrollTop()">
				   <span class="be-signet transparent">
					  <span class="path1"></span>
					  <span class="path2"></span>
				   </span>
				</div>
				<div class="pixels-message trail">
				   <div>
					  <span class="be-signet green">
						 <span class="path1"></span>
						 <span class="path2"></span>
					  </span>
				   </div>
				   <div>
					  <span class="burg-logo-slogan" id="whatWeDo"><b>BurgEins </b>würde hier klicken.</span>
				   </div>
				</div>
				<script type="text/html" id="messages">
				   <ul>
					  <li>würde hier klicken.</li>
					  <li>hilft, digitale Potenziale auszuschöpfen.</li>
					  <li>fährt hoch.</li>
					  <li>mäandert in Zeit und Raum.</li>
					  <li>gestaltet digitale Welten.</li>
					  <li>hat den besten Ausblick über Chemnitz.</li>
					  <li>steckt in Videoplayern weltweit.</li>
					  <li>kommuniziert.</li>
					  <li>rubbelt den Hund.</li>
					  <li>kreiert Display Ads.</li>
					  <li>wäscht sich die Hände.</li>
					  <li>> Burg Zwei</li>
					  <li>programmiert.</li>
					  <li>entwickelt interaktive Anwendungen.</li>
					  <li>geht mittags essen.</li>
				   </ul>
				<\/script>
			 </div>`;
			
			const pixelWallDOM = new DOMParser().parseFromString(beOriginDOM, 'text/html');
			const newPixelWallDiv = pixelWallDOM.querySelector('.pixels');
			newPixelWallDiv?.querySelector('#whatWeDo')?.addEventListener('click', () => getNewSentence(0));
			
			const pixelWallParent = oldPixelWallDiv.parentElement;
			
			pixelWallParent.replaceChild(newPixelWallDiv, oldPixelWallDiv);
		})
		setOldBePixelWallJS();
	}
	
	initialCarouselSetup();
	
	function setOldBePixelWallJS() {

		const setup = {
			"utils": {
				"environment": {
					innerWidth: function () {
						return window.innerWidth || window.document.documentElement.clientWidth || window.document.body.clientWidth
					},
					innerHeight: function () {
						return window.innerHeight || window.document.documentElement.clientHeight || window.document.body.clientHeight
					}
				},
				"visibility": {}
			},
			"model": {},
			"controller": {
				"navigation": {}
			},
			"view": {},
			"config": {},
			subscribe: function (a, b) {
				window.addEventListener(a, b)
			},
			trigger: function (a, b) {
				var c = new CustomEvent(a, {
					detail: b
				});
				window.dispatchEvent(c)
			}
		};
		
		I_beweb(setup);
		II_beweb(setup);
	}
	
	// original BE-web pixelWall-functions:
	
	
	
	var N = {
			},
			ia = function () {
				var a = {
						},
						d = 0;
		a.destroy = function () {
			clearInterval(d)
		}();
		return a
	}();

	
	const I_beweb = function (a) {
		var T = {
				},
				la,
				ma = window.getComputedStyle(document.documentElement, ''),
				V = (Array.prototype.slice.call(ma).join('').match(/-(moz|webkit|ms)-/) || '' === ma.OLink && [
					'',
					'o'
				]) [1],
			na = 'WebKit|Moz|MS|O'.match(new RegExp('(' + V + ')', 'i')) [1];
		la = {
			js: V[0].toUpperCase() + V.substr(1),
			dom: na,
			css: '-' + V + '-',
			lowercase: V
		};
		T.prefix = la;
		
		function d() {
			var a = document.querySelector('.pixels-message.trail'),
					b = document.querySelector('.pixels-message.fixed'),
					c = a.getBoundingClientRect().top,
				d = a.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
			0 < c ? q && (q = !1, b.style.transition = 'none', b.style[T.prefix.js + 'transition'] = 'none', b.style.position = 'absolute', b.style.top = d - a.getBoundingClientRect().top + 'px', setTimeout(function () {
				b.style.transition = 'all 0.2s linear';
				b.style[T.prefix.js + 'transition'] = 'all 0.2s linear';
				b.style.top = d + 'px';
				b.style.left = '5%';
				b.classList.remove('final')
			}, 50)) : q || (q = !0, b.style.transition = 'none', b.style[T.prefix.js + 'transition'] = 'none', b.style.position = 'fixed', b.style.top = c + b.getBoundingClientRect().height / 2 + 'px', setTimeout(function () {
				b.style.transition = 'all 0.2s linear';
				b.style[T.prefix.js + 'transition'] = 'all 0.2s linear';
				b.style.top = '25px';
				b.style.left = '2%';
				b.classList.add('final')
			}, 50))
		}
		function c() {
			if(!n) {
				return;
			}
			// 0 < n.getBoundingClientRect().bottom !== u && m.home.pixels.togglePlay()

			//replace with these 2 lines to always start:
			u = true;
			g()
		}
		function b() {
			if(!n) {
				return;
			}
			// 70% of screen:
			n.height = a.utils.environment.innerHeight() * .7;
			c()
		}
		function f() {
			if(!n) {
				return;
			}
			n.width = a.utils.environment.innerWidth();
			c()
		}
		function e(a, b) {
			if (t) h.fillStyle = y;
			else {
				var c = h,
						d = (Math.floor(256 * Math.random()) + 0).toString(16),
						d = 1 < d.length ? d : '0' + d;
				c.fillStyle = '#' + d + '' + d + '' + d;
			}
			h.fillRect(a, b, 52, 52)
		}

		// request animation frame instead of timeout
		let lastTime = new Date();
		const pause = 50;

		function g() {
			if (new Date() - lastTime > pause && u && null !== h) {
				var a = (new Date).getTime();
				0 === k && (k = a);
				var b = k - G;
				1000 <= b ? G = k : H = b / 10;
				k = a;
				h.globalAlpha = 0.03;
				var a = window.innerWidth + 52, b = window.innerHeight + 52;
				for (var c = 0; c <= a; c += 52) for (var d = 0; d <= b; d += 52) e(c, d);
				lastTime = new Date();
			}
			requestAnimationFrame(g);
		}
		function l(a, b, c, d) {
			e(a + c, b + d);
			0 !== c && e(a - c, b + d);
			0 !== d && e(a + c, b - d);
			0 !== c && 0 !== d && e(a - c, b - d)
		}
		
		var m = a.view || {
		};
		m.home = m.home || {
		};
		m.home.pixels = {
		};
		var h = null,
				n = null,
				u = !1,
				w = 52,
				p = 52,
				t = !1,
				y,
				x = null,
				k = 0,
				G = 0,
				H = 0,
				q = !1;
		m.home.pixels.togglePlay = function () {
			u = !u;
			g()
		};
		a.subscribe('mousemove', function (a) {
			if(!n) {
				return;
			}
			w = 52 * Math.round((a.clientX - n.offsetLeft) / 52);
			p = 52 * Math.round((a.clientY - n.offsetTop) / 52)
		});
		a.subscribe('click', function () {
			if (u) {
				t = !0;
				y = '#' + (16777216 * Math.random() | 0).toString(16);
				h.globalAlpha = 0.3;
				for (var a = 10; 0 < a; a--) if (10 * a < H) for (var b = w, c = p, d = 52 * a, e = - d, f = 0; d >= f; ) {
					var g = b,
							k = c,
							m = d,
							n = f;
							l(g, k, m, n);
							m !== n && l(g, k, n, m);
							e += f;
							f += 52;
							e += f;
							0 <= e && (d -= 52, e -= d, e -= d)
				}
				t = !1
			}
		});
		a.subscribe('scroll', c);
		a.subscribe('scroll', d);
		a.subscribe('resizecomplete', f);
		window.addEventListener('resize', f);
		a.subscribe('pageheightchange', b);
		a.subscribe('pageheightchange', d);

		h = function (a) {
			a = slider.querySelector(a);
			if (!a) {
				return;
			}
			if (a.querySelector('canvas')) {
				a.querySelector('canvas').remove();
			}
			a.insertAdjacentHTML('afterbegin', '<canvas></canvas>');
			n = a.querySelector('canvas');
			n.width = a.offsetWidth;
			n.height = a.offsetHeight;
			return n.getContext('2d')
		}('.sc-carousel__pages-container > *:first-child ~ .pixels');
		if(!h) {
			return;
		}
		if(!h.canvas) {
			return;
		}
		n = h.canvas;
		f();
		b();
		d()
	};
	
	const II_beweb = function (a) {
		
		var d = a.view || {
		};
		d.home = d.home || {
		};
		d.home.sentences = [
		];
		var c = - 1,
				b = 0;
		getNewSentence = a.getSentence = function (f) {
			if (f && 1 >= f) b = f;
			else for (; c === b; ) b = Math.round(Math.random() * (d.home.sentences.length - 3) + 2);
			c = b;
			f = d.home.sentences[b];
			const messages = document.querySelectorAll('.burg-logo-slogan');
			if (!messages) {
				return;
			}
			messages.forEach(message => {
				message.innerHTML = '<b>BurgEins </b>' + f.innerHTML;
			})
			// a.trigger(r.TRACKING_EVENT, {
			// name: r.TrackingEvent.CLICK,
			// type: r.TrackingType.FACTS,
			// v1: f.innerHTML,
			// v2: ''
			// });
			a.trigger('factrequested')
		};
		(function () {
			if(!document.querySelector('#messages')) {
				return;
			}
			var b = document.querySelector('#messages').innerText,
					b = (new DOMParser).parseFromString(b, 'text/html');
			d.home.sentences = b.querySelectorAll('li');
		})()
	};

	function maxSliderHeight(slideElement) {
		//PixelWall same height as other images, but all together max 70% of screen:
		const firstImage = slideElement.parentElement.parentElement.querySelector('img');
		const imagesHeight = firstImage.getBoundingClientRect().height || window.innerHeight * 0.7;
		return Math.min(imagesHeight, window.innerHeight * 0.7);
	}
	
	function calcSliderHeight() {
		const sliderDivs = slider?.querySelector('.sc-carousel__pages-container').children;
		if(!sliderDivs) {
			return;
		}
		let visibleImage = sliderDivs[(latestActiveSlideDetail || 0) + 1];

		if(!visibleImage) {
			return;
		}

		if(!latestActiveSlideDetail && sliderDivs[0].classList.contains('be_live_background')) {
			return;
		}

		if(visibleImage.classList.contains('pixels')) {
			setCanvasSize();
			return;
		}

		const image = visibleImage.querySelector('img');

		if(!image) {
			return;
		}

		function sliderHeightByImage() {
			let height = image.getBoundingClientRect().height;
			height = Math.min(image.getBoundingClientRect().height, window.innerHeight * 0.7);
			slider.style.height = `${height}px`;
		}

		image.complete? sliderHeightByImage() : image.addEventListener('load', sliderHeightByImage);
	}
	
	function setCanvasSize() {
		if(!slider) {
			requestAnimationFrame(setCanvasSize);
			return;
		}
		const canvas = slider.querySelector('canvas');
		if(!canvas) {
			requestAnimationFrame(setCanvasSize);
			return;
		}
		const height = maxSliderHeight(canvas);
		canvas.setAttribute('height', height);
		canvas.parentElement.style.height = `${height}px`;
		slider.style.height = `${height}px`;
		restartBECanvas();
	}

	let latestActiveSlideDetail = null;

	function restartBECanvas() {
		if(!slider || !slider.querySelector('.be_live_background')) {
			return;
		}
		setCanvasSize();
		if(!document.querySelector('.sc-carousel__pages-container > *:first-child ~ .pixels')) {
			requestAnimationFrame(restartBECanvas);
		}
		setTimeout(() => {
			setOldBePixelWallJS();
			calcSliderHeight();
			slider.querySelectorAll('.sc-carousel-button').forEach((button, i) => button.setAttribute('aria-label',
					`Slider-Button index: ${i}`));
		}, 200);
	}
	
	window.addEventListener('resize', () => {restartBECanvas(); calcSliderHeight()});

	window.addEventListener('animatedPagesDone', () => setTimeout(() => restartBECanvas(), 200));

	window.addEventListener('navigated', restartBECanvas);

	let carousel;

	onMount(() => {
		const startPage = parseInt(getPagesFixedRandomContent(isRightSide, pageContentIndex)) || 0;
		restartBECanvas();
		calcSliderHeight();
		// wait a bit till slides were attached:
		setTimeout(() => {
			carousel.goTo(startPage, { animated: false });
		}, 200);
	})

	onDestroy(() => {
		restartBECanvas();
	})
</script>

<div bind:this={slider} class="slider">
	<Carousel
		bind:this={carousel}
		autoplay={isRightSide}
		autoplayDuration={15000}
		pauseOnFocus
		let:showPrevPage
		let:showNextPage
		let:loaded
		on:pageChange={ event => {
			latestActiveSlideDetail = event.detail;
			setPagesFixedRandomContent(pageContentIndex, `${latestActiveSlideDetail}`);
			setOldBePixelWallJS();
			calcSliderHeight();
		}}
	>
		<div class="clickbox prev" on:click={showPrevPage} slot="prev">
			<div class="custom-arrow custom-arrow-prev">
				<i/>
			</div>
		</div>

		<slot/>

		<div class="clickbox next" on:click={showNextPage} slot="next">
			<div class="custom-arrow custom-arrow-next">
				<i/>
			</div>
		</div>
	</Carousel>
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.slider {
		width: 100%;
		hyphens: auto;
		transition: height .2s .2s;
		max-height: 80vh;

		.clickbox {
			height: 100%;
			width: 50px;
			position: absolute;
			cursor: pointer;
			z-index: 10;

			&.next {
				right: 0;
			}
		}
		
		.custom-arrow {
			width: 50px;
			background-color: #000000;
			opacity: 0.3;
			position: absolute;
			top: 0;
			bottom: 0;
			z-index: 1;
			transition: opacity 150ms ease;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			-webkit-tap-highlight-color: transparent;
			
			> i {
				border: solid #dedede;
				border-width: 0 5px 5px 0;
				padding: 10px;
				position: relative;
			}
		}
		
		.custom-arrow-prev {
			left: 0;
			
			> i {
				transform: rotate(135deg);
				right: -4px;
			}
		}
		
		.custom-arrow-next {
			right: 0;
			
			> i {
				transform: rotate(-45deg);
				left: -4px;
			}
		}
		
		img {
			height: fit-content;
		}

		.ctaText {
			position: absolute;
			left: 0;
			top: 0;
			width: 75%;
			height: 100%;
			// copied from XD:
			background: transparent linear-gradient(90deg, rgba(0,0,0,.6) 0%, rgba(0,0,0,0) 100%);
			color: white;

			display: flex;
			flex-direction: column;
			justify-content: center;
			padding-left: 55px;

			h2, span {
				// copied from XD:
				text-shadow: 0px 3px 6px #00000029;
			}

			span {
				min-width: 100%;

				@include for-tablet-landscape-up {
					min-width: unset;
				}
			}

			.button {
				border-radius: 5px;
				padding: 1rem 3rem;
				width: fit-content;
				margin-top: 5rem;
				background: transparent;
				border: 1px solid #FFFFFF;
				color: white;
				transition: background .2s, color .2s;

				&:hover {
					background: white 0% 0% no-repeat padding-box;
					color: black;
				}
			}

			@include for-tablet-landscape-up {
				width: calc(100% / 3 * 2);
				padding-left: 15rem;

				span {
					width: 90%;
					min-width: 400px;
				}
			}
		}
		
		.sc-carousel__carousel-container,
		.sc-carousel__content-container {
			height: 100%;
		}

		.sc-carousel__pages-window {
			z-index: 0;
		}

		.sc-carousel-dots__container {
			margin-top: px-to-rem(-50);
			width: 90vw;
			max-width: 400px;
			display: flex;
			z-index: 1;
		}

		.sc-carousel-dots__dot-container {
			flex: 1;
		}

		.sc-carousel-dot__dot {
			outline: none;
			width: 80%;
			border-radius: 0;
			background-color: var(--color-burgeins-4);
		}

		.sc-carousel-dot__dot_active {
			background-color: var(--color-burgeins-6);
		}
		
		.pixels {
			position: relative;
			// 70% of screen:
			height: calc(100vh * 0.7);
			display: flex;
			
			canvas {
				height: 100%;
				width: 100%;
				z-index: -1;
			}
		}

		div {
			position: relative;
		}

		div a {
			button {
				position: absolute;

				&.top-0_left-0_button {
					top: 0;
					left: 0;
				}
			}
		}
		
		.special_0 {
			width: 100vw;
		}
		
		[class*="special"] p {
			font-weight: 100;
		}
		
		[class*="special"] h2 {
			font-weight: 600;
		}
		
		.special_1 {
			background-color: $color-burgeins-3;
			display: flex;
			flex-flow: column;
			padding: var(--spacing-mobile);
			
			@include for-tablet-landscape-up {
				flex-flow: row;
				padding: 8.5vw 8vw 9vw 8vw;
				
				h2 {
					font-size: 4rem;
					line-height: 4rem;
				}
			}
		}
		
		.w_100.special_w_100_60 {
			margin-top: calc(var(--spacing-mobile) * 1.5);
		}
		
		.special_w_100_60 h2 {
			width: 60%;
		}
		
		.special_w_100_portfolio {
			p {
				margin-bottom: $spacing-mobile-half;
			}
			
			h3,
			p:first-of-type, {
				margin-bottom: $spacing-mobile;
			}
		}
		
		.special_w_100_60 p {
			@include for-tablet-landscape-up {
				margin-bottom: $spacing-mobile-half;
			}
		}
		
		.w_60 {
			padding-left: 0;
			
			@include for-tablet-landscape-up {
				padding-left: 40%;
			}
		}
		
		.left.w_60 {
			padding-left: 0;
			padding-right: 40%;
		}
		
		.w_80 {
			padding-left: 20%;
		}
		
		.left.w_80 {
			padding-left: 0;
			padding-right: 20%;
		}
		
		.w_100 {
			margin: 0 $spacing-mobile;
			
			h1 {
				margin: $spacing-mobile 0;
			}
			
			h2 {
				margin: $spacing-mobile-half 0;
			}
			
			h3, h4 {
				margin-bottom: $spacing-mobile*.3;
			}
			
			h5 {
				margin: $spacing-mobile-half 0;
			}
		}
		
		p, img {
			width: 100%;
			height: auto;
			top: 50%;
			transform: translateY(-50%);
			position: absolute;
			min-width: 100%;
			min-height: 100%;
			object-fit: cover;
		}

		.right.w_60 p {
			padding: calc(var(--spacing-mobile) * 2.2) var(--spacing-mobile) calc(var(--spacing-mobile) / 2) var(--spacing-mobile);
			
			@include for-tablet-landscape-up {
				padding: calc(var(--spacing-tablet) * .8) var(--spacing-tablet) var(--spacing-tablet) 0;
			}
		}
		
		.right.w_60::before {
			content: "-";
			color: black;
			position: absolute;
			left: 0.4em;
			font-size: 5em;
			line-height: 0;
			margin-top: 0.4em;
			
			@include for-tablet-landscape-up {
				left: calc(var(--spacing-tablet) * 2);
				font-size: 6.5em;
				margin-top: calc(var(--spacing-tablet) * .9);
			}
		}
		
		.special_fullwidthbgcolor {
			margin: 0;
			background-color: black;
		}
		
		.special_header {
			margin: 0 $spacing-mobile;
			max-width: 1425px;
		}
	}
</style>
